// iOS Safari blocks window.open() when it doesn't run in the same synchronous
// tick as the user gesture. Open the tab up-front and navigate it once the URL
// resolves; never await before window.open.
export function openTabWithUrl(getUrl) {
    const tab = window.open("", "_blank");
    return Promise.resolve()
        .then(getUrl)
        .then(url => {
            if (!url) throw new Error("Missing URL");
            if (tab && !tab.closed) tab.location.href = url;
            else window.location.href = url;
            return url;
        })
        .catch(err => {
            if (tab && !tab.closed) tab.close();
            throw err;
        });
}
